<template>
    <div id="changeBookingContact">
        <div class="stateroomDetail-t stateroomDetail-t2 js-returnDetailBtn">
            <a class="stateroomDetail-returnButton" @click="goBack">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
            <p class="stateroomDetail-t-title">修改联系人信息</p>
            <div class="privacy-layout">
              <privacy-button @privacy-switch="reload" type="text"></privacy-button>
            </div>
        </div>
        <div class="popupover2-m">
            <div class="modify scroll-container js-smartScroll">
                <div class="modify-box">
                    <div class="modify-cell">
                        <div class="modify-cell-title">联系人</div>
                        <div class="modify-cell-inputBox">
                            <input type="text" v-model="bookingContact.name" data-key="Name" class="js-hasClose" @focus="txtFocus" id="modifyName">
                        </div>
                        <div class="modify-cell-close" @click="bookingContact.name=''">
                            <img class="input-clear" src="https://resource.rcclchina.com.cn/tui2/cruise/contact-clear.png" style="display: inline;">
                        </div>
                    </div>
                    <div class="modify-cell">
                        <div class="modify-cell-title">
                            手机号
                        </div>
                        <div class="modify-cell-inputBox">
                            <span class="passenger-callingCode callingCode-text">
                                {{selectedCallingCode.countryName}}({{selectedCallingCode.callingCode}})  
                            </span>
                            <select class="callingCode-css callingCode-js" @change="onCallingCodeChange($event)" @click="onCallingCodeClick">
                                <option v-for="(code, i) in callingCodes" :key="i" :value="code.callingCode" 
                                >
                                    {{`${code.countryName}(${code.callingCode})`}}
                                </option>
                            </select>
                            <input type="tel" v-model="bookingContact.telephone" data-key="Telephone" class="js-hasClose" @focus="txtFocus" id="modifyPhone">
                        </div>
                        <div class="modify-cell-close" @click="bookingContact.telephone=''">
                            <img class="input-clear" src="https://resource.rcclchina.com.cn/tui2/cruise/contact-clear.png" style="display: inline;">
                        </div>
                    </div>
                    <div class="modify-cell">
                        <div class="modify-cell-title">电子邮箱</div>
                        <div class="modify-cell-inputBox">
                            <input type="text" v-model="bookingContact.email" data-key="Email" class="js-hasClose" @focus="txtFocus" id="modifyEmail">
                        </div>
                        <div class="modify-cell-close" @click="bookingContact.email=''">
                            <img class="input-clear" src="https://resource.rcclchina.com.cn/tui2/cruise/contact-clear.png" style="display: inline;">
                        </div>
                    </div>
                    <div class="modify-cell js-verify" v-show="needSmsCode">
                        <div class="modify-cell-title">验证码</div>
                        <div class="modify-cell-inputBox">
                            <input v-model="picCode" type="text" value="" data-key="ModifyImgCode" id="modifyImgCode" maxlength="4">
                        </div>
                        <div class="modify-cell-imgCode">
                            <img :src="picCodeImage" id="imgCode" @click="getPicCode">
                        </div>
                    </div>
                    <div class="modify-cell js-verify" v-show="needSmsCode">
                        <div class="modify-cell-title">短信验证码</div>
                        <div class="modify-cell-inputBox">
                            <input v-model="smsCode" type="tel" value="" data-key="ModifySmsCode" id="modifySmsCode" >
                        </div>
                        <div class="modify-cell-txt" id="smsBtn" @click="sendSmsCode()">
                            {{smsCodeText}}
                        </div>
                    </div>
                </div>

                <div class="modify-btn" @click="submitContact">保 存</div>

            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
const PrivacyButton = () => import('@/components/Common/PrivacyButton')
export default {
    name: "ChangeBookingContact",
    components: {
      PrivacyButton
    },
    data () {
        return {
            smsCodeCountDown: 0,
            picCodeImage: '',
            callingCodes: [],
            oldTelephone: {

            },
            bookingContact: {
                name: '',
                bookingId: '',
                email: '',
                telephone: '',
                callingCode: '86',
                id: 0
            },
            contact: {},
            picCode: "",
            smsCode: "",
            selectedCallingCode: {},
            updateFields: []
        }
    },
    beforeMount () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: true, isHideFooter: true})
        
        this.initPage()
        this.getPicCode()
        
    },
    beforeDestroy () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
    },
    methods: {
        reload() {
          location.reload();
        },
        async initPage() {
            this.updateFields = [];
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                return this.$router.push({ name: 'Login', query:{ 
                    returnUrl: encodeURIComponent(location.href)
                }})
            }

            const query = this.$router.currentRoute.query
            if (!query || !query.bookingId || query.bookingId == '') {
                return this.$router.go(-1)
            }
            this.$loading.show()
            await this.getCallingCodes()
            const { success, data, errMsg } = await api.booking.bookingDetail({
                bookingId: query.bookingId,
                userName: userToken
            })
            this.$loading.hide()
            if (!success) {
                console.error(errMsg)
            } else if (data.bookingRecordApi && data.bookingRecordApi.bookingContacts){
                let bookingContact = data.bookingRecordApi.bookingContacts[0] || {};
                let name = bookingContact.chineseLastName + bookingContact.chineseFirstName
                if (name == '') {
                    name = bookingContact.pinYinLastName + ' ' + bookingContact.pinYinFirstName
                }
                this.contact = Object.assign({}, bookingContact);
                this.bookingContact = {
                    name: name,
                    bookingId: query.bookingId,
                    email: bookingContact.email,
                    telephone: bookingContact.telephone,
                    callingCode: bookingContact.callingCode || '86',
                    id: bookingContact.id
                }
                this.oldTelephone = {
                    telephone: bookingContact.telephone,
                    callingCode: bookingContact.callingCode
                }
                this.selectedCallingCode = this.getCallingCode(bookingContact.callingCode)
            }
        },
        async getCallingCodes () {
            const { success, data, errMsg } = await api.page.getCallingCode()
            if (!success) console.error(errMsg)
            this.callingCodes = data
        },
        // 获取图形验证码
        async getPicCode () {
            const { success, data, errMsg } = await api.user.picCode(this.smsKey)
            if (!success) console.error(errMsg)
            if (data) {
                this.picCodeImage = "data:image/png;base64," + data.imageBase64
                this.$store.dispatch('SET_SESSION_KEY', data.sessionKey)
            }
        },
        // 获取短信验证码
        async sendSmsCode (){
            if (this.smsCodeCountDown > 0) {
                return
            }
            this.$loading.show()
            let callingCode = this.bookingContact.callingCode
            if (callingCode && callingCode.length > 1 && callingCode.indexOf("+") == 0) {
                callingCode = callingCode.substring(1)
            }
            const { success, errMsg } = await api.user.smsCode({
                phone: this.bookingContact.telephone,
                picCode: this.picCode,
                callingCode: callingCode,
                sessionKey: this.smsKey
            })
            this.$loading.hide()
            if (!success) {
                console.error(errMsg)
                this.$alert.show(errMsg)
                return
            } else {
                this.$alert.show("短信发送成功！若您没有收到短信验证，请一分钟后重新发送。")
            }
            this.getPicCode()
            this.smsCodeCountDown = 60
            const self = this
            let countDown = setInterval(()=> {
                if (self.smsCodeCountDown == 0) {
                    clearInterval(countDown)
                } else {
                    self.smsCodeCountDown--
                }
            }, 1000)
        },
        async submitContact () {
            let data = {...this.bookingContact}
            data.code = this.smsCode
            data.UpdateFields = this.updateFields
            if(this.updateFields.length === 0) {
              return this.$alert.show('没有任何修改')
            }

            if (!data.name || data.name == '' || data.name.length < 2) {
                return this.$alert.show("请输入联系人姓名")
            } else if (!data.telephone || data.telephone == '') {
                return this.$alert.show("请输入联系人手机号")
            } else if (!data.email || data.email == '') {
                return this.$alert.show("请输入联系人邮箱")
            }

            if(!this.isMaskValue || this.updateFields.includes('Telephone')) {
              if (this.needSmsCode && (!data.code || data.code == '')) {
                return this.$alert.show("请输入短信验证码")
              }
            }

            const requestData = {
                model: data,
                sessionKey: this.smsKey
            }
            this.$loading.show()
            const { success, errMsg } = await api.booking.changeBookingContact(requestData)
            this.$loading.hide()
            if (!success) {
                return this.$alert.show(errMsg)
            } else {
                this.$alert.show('修改成功', {
                    confirmCallBack: ()=> {
                        this.goBack()
                    }
                })
            }
        },
        getCallingCode (code) {
            code = code ? code : '+86';
            if (code.indexOf('+') < 0) {
                code = '+' + code
            }
            return this.callingCodes.find(r=>r.callingCode == code)
        },
        onCallingCodeChange (e) {
            const value = e.target.value
            const callingCode = this.callingCodes.find(r=> r.callingCode == value)
            if (callingCode) {
                this.selectedCallingCode = callingCode
            }
        },
        onCallingCodeClick () {
          if(!this.updateFields.includes('Nationality')) {
            this.updateFields.push('Nationality')
          }
        },
        goBack () {
            const query = this.$router.currentRoute.query
            if (query.returnUrl && query.returnUrl.length > 0) {
                location.href = query.returnUrl
            } else {
                this.$router.go(-1)
            }
            
        },
        txtFocus(e) {
          let dataKey = e.target.getAttribute('data-key')
          if(this.isMaskValue) {
            switch (dataKey) {
              case 'Name':
                if(!this.updateFields.includes("ChineseLastName") || !this.updateFields.includes("ChineseFirstName")) {
                  this.bookingContact.name = "";
                  this.updateFields.push("ChineseLastName");
                  this.updateFields.push("ChineseFirstName");
                }
                break;
              case 'Telephone':
                if(!this.updateFields.includes("Telephone")) {
                  this.bookingContact.telephone = "";
                  this.updateFields.push("Telephone");
                }
                break;
              case 'Email':
                if(!this.updateFields.includes("Email")) {
                  this.bookingContact.email = "";
                  this.updateFields.push("Email");
                }
                break;
            }
          }

          if(dataKey === "Name" && (!this.updateFields.includes("ChineseLastName") || !this.updateFields.includes("ChineseFirstName"))) {
            this.updateFields.push("ChineseLastName");
            this.updateFields.push("ChineseFirstName");
          } else if(!this.updateFields.includes(dataKey)) {
            if(dataKey !== "Name") this.updateFields.push(dataKey);
          }
        }
    },
    computed: {
        smsKey() {
            return this.$store.state.page.sessionKey
        },
        smsCodeText () {
            if (this.smsCodeCountDown <= 0) {
                return "发送验证码"
            } else {
                return `验证码(${this.smsCodeCountDown}s)`
            }
        },
        needSmsCode () {
            const userMobile = this.$store.state.user.userInfo.mobileH
            return userMobile != this.bookingContact.telephone && 
            (this.bookingContact.telephone != this.oldTelephone.telephone 
            || this.bookingContact.callingCode != this.oldTelephone.callingCode)
        },
        isMaskValue() {
          return this.$store.state.page.isMaskValue;
        }
    }
}
</script>

<style lang="less" scoped>
#changeBookingContact {
    img {
        max-width: 100%;
    }
    .stateroomDetail-t {
        position: fixed;
        width: 100%;
        text-align: center;
        height: 50px;
        line-height: 50px;
        background-color: #fff;
        top: 0;
        left: 0;
        z-index: 5001;
        .stateroomDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 4px;
            left: 20px;
            text-align: left;
            img {
                width: 33%;
            }
        }
        .stateroomDetail-t-title {
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            margin: 0;
        }
        .privacy-layout {
          font-size: 0;
          line-height: 1;
          position: absolute;
          top: 0;
          right: 10px;
        }
    }

    .popupover2-m {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -moz-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        .modify {
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -moz-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            overflow-y: auto;
            padding-top: 10px;
            .modify-box {
                margin-bottom: 10px;
                padding: 9px 20px 83px;
                background-color: #fff;
                .modify-cell {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: center;
                    -webkit-align-items: center;
                    -moz-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    height: 45px;
                    border-bottom: 1px solid #E5E5E5;
                    .modify-cell-title {
                        -webkit-box-flex: 0;
                        -webkit-flex: none;
                        -moz-box-flex: 0;
                        -ms-flex: none;
                        flex: none;
                        width: 82px;
                        font-size: 14px;
                        line-height: 20px;
                        color: #333;
                    }
                    .modify-cell-inputBox {
                        -webkit-box-flex: 1;
                        -webkit-flex: 1;
                        -moz-box-flex: 1;
                        -ms-flex: 1;
                        flex: 1;
                        position: relative;
                        input {
                            width: 100%;
                            height: 20px;
                            font-size: 14px;
                            line-height: 20px;
                            color: #333;
                        }
                        input#modifyPhone {
                            width: 100px;
                            display: inline-block;
                            vertical-align: middle;
                        }
                        .callingCode-text {
                            background: url(https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-down-1.jpg) no-repeat right transparent;
                            border: 0;
                            -moz-appearance: none;
                            -webkit-appearance: none;
                            padding-right: 20px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            display: inline-block;
                            vertical-align: middle;
                            margin-right: 5px;
                            font-size: 14px;
                            line-height: 20px;
                            color: #333;
                            max-width: 120px;
                        }
                        select.callingCode-css {
                            position: absolute;
                            left: 0px;
                            top: 5px;
                            opacity: 0;
                            z-index: 2;
                            width: 88px;
                            vertical-align: -webkit-baseline-middle;
                            border: none;
                            font-size: 13px;
                            text-indent: 10px;
                            appearance: menulist-button;
                            -webkit-appearance: menulist-button;
                            -moz-appearance: menulist-button;
                            font-weight: bold;
                            color: #333;
                        }
                        .modify-cell-imgCode {
                            -webkit-box-flex: 0;
                            -webkit-flex: none;
                            -moz-box-flex: 0;
                            -ms-flex: none;
                            flex: none;
                            width: 60px;
                            height: 22px;
                            margin-left: 10px;
                            img {
                                display: block;
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                    .modify-cell-txt {
                        -webkit-box-flex: 0;
                        -webkit-flex: none;
                        -moz-box-flex: 0;
                        -ms-flex: none;
                        flex: none;
                        margin-left: 10px;
                        font-size: 12px;
                        line-height: 16px;
                        color: #006bb9;
                    }
                    .modify-cell-close {
                        -webkit-box-flex: 0;
                        -webkit-flex: none;
                        -moz-box-flex: 0;
                        -ms-flex: none;
                        flex: none;
                        width: 15px;
                        margin-left: 10px;
                    }
                }
            }
        }
    }
    .input-clear {
        display: none;
        width: 15px;
        height: 15px;
    }

    .modify input, .modify select {
        -webkit-appearance: none;
        outline: none;
        border: none;
        border-radius: 0;
        padding: 0;
        background-color: transparent;
    }
    .modify-btn {
        width: 100%;
        height: 50px;
        font-size: 16px;
        line-height: 50px;
        color: #454545;
        text-align: center;
        background: -webkit-gradient(linear, left top, right top, from(#FEBC10), to(#FAD961));
        background: -webkit-linear-gradient(left, #FEBC10, #FAD961);
        background: -moz-linear-gradient(left, #FEBC10, #FAD961);
        background: -o-linear-gradient(left, #FEBC10, #FAD961);
        background: linear-gradient(to right, #FEBC10, #FAD961);
    }
}

</style>